<template>
  <div class="club-page container-fluid">
    <!-- Título principal -->
    <div class="page-header text-center">
      <p class="page-subtitle">Bienvenido al ERP Araucann Soft</p>
    </div>

  
    <!-- Agrega otros componentes del dashboard aquí -->
  </div>
</template>

<script>

export default {
  name: 'ClubPage',
  components: {

  },
  data() {
    return {
      pageTitle: 'Club de Cultivo de Cannabis',
    };
  },
};
</script>

<style scoped>
/* Contenedor general de la página */
.club-page {
  background-color: #f7f8fa; /* Fondo claro */
  padding: 40px 20px; /* Espaciado */
  min-height: 100vh;
}

/* Título principal */
.page-header {
  margin-bottom: 30px;
}

.page-title {
  font-size: 3rem; /* Aumentar el tamaño del título */
  font-weight: bold;
  color: #333;
}

.page-subtitle {
  font-size: 1.3rem; /* Ajustar el tamaño del subtítulo */
  color: #666;
}

/* Tarjeta del gráfico */
.card {
  background-color: #ffffff; /* Fondo blanco para la tarjeta */
  border: none; /* Eliminar bordes */
  border-radius: 10px; /* Bordes suaves */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* Sombra sutil */
  padding: 20px;
}

.chart-card {
  margin: 0 auto;
  max-width: 1000px; /* Ajustar el tamaño para pantallas grandes */
  width: 90%; /* Ocupar el 90% del ancho de la pantalla */
}

.card-title {
  font-size: 1.7rem;
  margin-bottom: 20px;
}

/* Ajustes generales de tipografía */
body {
  font-family: 'Roboto', sans-serif; /* Fuente moderna */
  line-height: 1.6;
}

.container-fluid {
  max-width: 90%; /* Ocupar el 90% del ancho de la pantalla */
  margin: 0 auto;
  padding: 20px;
}
</style>
